import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import sortBy from 'lodash/sortBy';
import PropTypes from 'prop-types';

import tcModel from '@module/consent-manager/tc-model';
import I18n from '@module/i18n';

import Switch from '@component/form/element/switch';
import Chevron from './chevron';

import { initVendorListState } from './helper';
import { DescriptionContainer, VendorDescription } from './descriptions';

export function VendorList({ gvlLanguage }) {
  const [preferences, setPreferences] = useState(
    initVendorListState(gvlLanguage)
  );

  useEffect(() => {
    setPreferences(initVendorListState(gvlLanguage));
  }, [gvlLanguage]);

  const handleVendorConsent = (id, checked) => {
    const newPref = { ...preferences };
    newPref[id].consent = checked;
    setPreferences(newPref);

    if (checked) {
      tcModel.vendorConsents.set(id);
      return;
    }

    tcModel.vendorConsents.unset(id);
  };

  const content = {
    title: {
      __html: I18n.t('transfer.consent-manager.partners-headline'),
    },
    intro: {
      __html: I18n.t('transfer.consent-manager.partners-text'),
    },
    byWeTransfer: I18n.t('transfer.consent-manager.switch-by-we-transfer'),
    byPartners: I18n.t('transfer.consent-manager.switch-by-partners'),
  };

  const toggleDescription = (id) => {
    const newPref = { ...preferences };
    newPref[id].descriptionVisible = !newPref[id].descriptionVisible;
    setPreferences(newPref);
  };

  return (
    <React.Fragment>
      <div
        className="welcome__cookie-notice-title welcome__consent-title"
        dangerouslySetInnerHTML={content.title}
      />
      <div
        className="welcome__cookie-notice-text"
        dangerouslySetInnerHTML={content.intro}
      />
      {Object.values(sortBy(preferences, ['name'])).map((consent) => (
        <div key={consent.id} className="consent-accordion">
          <div className="consent-accordion__section">
            <div className="consent-accordion__header">
              <div onClick={() => toggleDescription(consent.id)}>
                <Chevron
                  className={classNames('consent-accordion__icon', {
                    'consent-accordion__icon consent-accordion__icon--rotated':
                      consent.descriptionVisible,
                  })}
                  width="10"
                />
                <p className="consent-accordion__title">{consent.name}</p>
              </div>
              <div className="consent-accordion__switches_partners">
                <Switch
                  name={`vendor-consent-${consent.id}`}
                  label={content.byPartners}
                  onChange={(checked) =>
                    handleVendorConsent(consent.id, checked)
                  }
                  checked={consent.consent}
                />
              </div>
            </div>
          </div>
          <DescriptionContainer isVisible={consent.descriptionVisible}>
            <VendorDescription
              purposeDescriptions={consent.purposeDescriptions}
              featureDescriptions={consent.featureDescriptions}
              policyUrl={consent.policyUrl}
            />
          </DescriptionContainer>
        </div>
      ))}
    </React.Fragment>
  );
}

VendorList.propTypes = {
  gvlLanguage: PropTypes.object,
};
